export default __webpack_public_path__ + "static/abhi-792912a6cf38d1686a6a47dba5e40607.jpeg";